import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ArtifactUploadFieldsSchema } from './shapes';

export const presignReleaseUpload = defineEndpoint({
  method: 'POST',
  path: '/v1/release-uploads/presign',
  params: z.object({}),
  query: z.object({}),
  body: ArtifactUploadFieldsSchema,
  response: z.object({
    data: z.object({ url: z.string(), storagePath: z.string(), expiresAt: z.string() }),
  }),
});
